import { render, staticRenderFns } from "./ProductCombosModal.vue?vue&type=template&id=3bf4a96a"
import script from "./ProductCombosModal.vue?vue&type=script&lang=ts"
export * from "./ProductCombosModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports